import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { UserAssignment } from '@app/shared/models/user-assignment';


export interface DepartmentDialogData {
    userAssignments: UserAssignment[];
}

@Component({
    selector: 'department-dialog',
    templateUrl: './department-dialog.component.html',
    styleUrls: ['./department-dialog.component.scss']
})
export class DepartmentDialogComponent extends BaseComponent implements OnInit {

    public selectedUserAssignment: UserAssignment;

    constructor(public dialogRef: MatDialogRef<DepartmentDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DepartmentDialogData) {
        super();
    }

    public ngOnInit() {
        if (this.data.userAssignments && this.data.userAssignments.length === 1) {
            this.selectedUserAssignment = this.data.userAssignments[0];
        }
    }

    public accept(): void {
        this.dialogRef.close({ department: this.selectedUserAssignment });
    }
}
